import { useMemo } from 'react';
import { useCollection } from 'react-firebase-hooks/firestore';
import { collection, query, orderBy, where, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '@/lib/firebase/config';
import { COLLECTIONS, splitPath } from '@elka/firebase';
import { useAuth } from '../../auth/hooks/useAuth';
import type { Deal, DealInput } from '@elka/types';

export function useDeals(companyId?: string) {
  const { user } = useAuth();

  const dealsQuery = useMemo(
    () =>
      companyId
        ? query(
            collection(db, ...splitPath(COLLECTIONS.crm.deals)),
            where('companyId', '==', companyId),
            orderBy('name', 'asc')
          )
        : query(collection(db, ...splitPath(COLLECTIONS.crm.deals)), orderBy('name', 'asc')),
    [companyId]
  );

  const [snapshot, loading, error] = useCollection(dealsQuery);

  const deals: Deal[] =
    (snapshot?.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })) as Deal[]) || [];

  const addDeal = async (data: DealInput): Promise<string> => {
    if (!user) throw new Error('לא מחובר');

    const docRef = await addDoc(collection(db, ...splitPath(COLLECTIONS.crm.deals)), {
      ...data,
      userId: user.uid,
      createdBy: user.displayName || user.email || 'Unknown',
      createdAt: serverTimestamp(),
    });

    return docRef.id;
  };

  return { deals, loading, error, addDeal };
}
